import { render, staticRenderFns } from "./merchantDialog.vue?vue&type=template&id=19370170"
import script from "./merchantDialog.vue?vue&type=script&lang=js"
export * from "./merchantDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports